<template>
  <AppOverlay v-model="isOpen">
    <CloseBtn class="close" icon-color="secondary" @click="isOpen = false" />
    <AppImg :src="example.src" :alt="$tt(`visa_example_${countryKey}`)" />
  </AppOverlay>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import type { Image } from '~/types';

const countryKey = inject(countryKeyInjectionKey)!;
const isOpen = defineModel<boolean>({ required: true });
defineProps<{
  example: Image;
}>();
</script>

<style scoped>
.close {
  position: absolute;
  top: var(--space-3);
}
img {
  max-height: 85vh;
}
</style>